import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTimeRequest,
  updatedTimeApproved,
  updatedTimeRejected,
} from '../../../../redux/MainAction';
import moment from 'moment';
import Toggle from 'react-toggle';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';

const Approved = () => {
  const dispatch = useDispatch();

  const request = useSelector((state) => state?.Webtracker?.timeRequest);
  const [showReset, setShowReset] = useState(false);

  const date = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(date.getDate() - 1);

  useEffect(() => {
    getList();
  }, []);

  const [filters, setFilters] = useState({
    startDate: moment(tomorrow).format('YYYY-MM-DD'),
    endDate: moment(date).format('YYYY-MM-DD'),
  });

  const getList = () => {
    var data = {
      offset: 0, // optional
      limit: 50, // optional,
      approvalStatus: 'APPROVED',
      startDate: filters?.startDate, // required
      endDate: filters?.endDate, // required
    };
    dispatch(getTimeRequest(data));
  };

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleApply = (e) => {
    e.preventDefault();
    if (filters?.startDate && filters?.endDate) {
      const startDate = moment(filters.startDate);
      const endDate = moment(filters.endDate);

      if (startDate.isAfter(endDate)) {
        toast.error('Start date cannot be greater than End date', {
          position: 'top-right',
        });
        return;
      }
    }

    const payload = { approvalStatus: 'APPROVED' };

    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }

    if (filters?.endDate) {
      payload.endDate = filters.endDate;
    }
    dispatch(getTimeRequest(payload));
    setShowReset(true);
  };

  const handleReset = (e) => {
    e.preventDefault();
    const data = {
      approvalStatus: 'APPROVED',
      startDate: moment(tomorrow).format('YYYY-MM-DD'),
      endDate: moment(date).format('YYYY-MM-DD'),
    };
    dispatch(getTimeRequest(data));
    setShowReset(false);
    setFilters({
      approvalStatus: 'APPROVED',
      startDate: moment(tomorrow).format('YYYY-MM-DD'),
      endDate: moment(date).format('YYYY-MM-DD'),
    });
  };
  console.log('approved', request);

  //   const handleApprove = (id)=>{
  //     console.log("id",id);
  //     var data = {
  //       id:id
  //     }
  //     dispatch(updatedTimeApproved(data))

  //   }
  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center m-b-20">
        <div
          className="d-flex align-items-center font-14 ml-2"
          style={{ gap: '5px' }}
        >
          <input
            type="date"
            className="form-control font-14"
            name="startDate"
            value={filters?.startDate}
            onChange={onChangeFilter}
            max={moment().format('YYYY-MM-DD')}
          />
          To
          <input
            type="date"
            className="form-control font-14"
            name="endDate"
            value={filters?.endDate}
            onChange={onChangeFilter}
            max={moment().format('YYYY-MM-DD')}
          />
          <Button
            className="d-flex align-items-center justify-content-center ml-2"
            style={{ padding: '6px 14px' }}
            size="sm"
            color="primary"
            onClick={handleApply}
          >
            <i className="ion-ios7-search font-20"></i>
          </Button>
          {showReset ? (
            <Button
              className="d-flex align-items-center justify-content-center ml-2"
              style={{ padding: '6px 13px' }}
              size="sm"
              color="danger"
              onClick={handleReset}
            >
              <i className="mdi mdi-close font-20"></i>
            </Button>
          ) : (
            ''
          )}
        </div>
      </div>
      <div>
        <table
          id="datatable"
          className="table dt-responsive nowrap table-vertical"
          width="100%"
          cellSpacing="0"
        >
          <thead>
            <tr>
              <th>Member</th>
              <th>Timezone</th>
              <th>Project</th>
              <th>Project Task</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Approved</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {request?.rows?.length > 0 ? (
              request?.rows?.map((item, idx) => (
                <tr>
                  <td>
                    {item?.projectTaskActivityRequestEmployee?.firstName}{' '}
                    {item?.projectTaskActivityRequestEmployee?.lastName}{' '}
                  </td>
                  <td>{item?.timezone}</td>
                  <td>{item?.projectTask?.project?.name}</td>
                  <td>{item?.projectTask?.name}</td>
                  <td>
                    {moment(item?.startTime).format('MMMM Do YYYY, h:mm:ss a')}
                  </td>
                  <td>
                    {moment(item?.endTime).format('MMMM Do YYYY, h:mm:ss a')}
                  </td>
                  <td>
                    <Toggle
                      checked={
                        item?.approvalStatus === 'APPROVED' ? true : false
                      }
                      //   onClick={() => handleApprove(item?.id)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No Records Found.
                </td>
              </tr>
            )}
            {/* Add other rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Approved;
